import axios from 'axios';

import { env } from 'config';
import { TradeMethod } from 'types';

import { createCrudApi } from './crud.api';

const path = '/trade-methods';
const url = `${env.apiUrl}${path}`;

const updateStatus = async ({
  id,
  enabled,
}: {
  id: string;
  enabled: boolean;
}): Promise<TradeMethod> =>
  (await axios.patch(`${url}/${id}/status`, { enabled })).data;

export const tradeMethodsApi = {
  updateStatus,
  ...createCrudApi<TradeMethod>(path),
};
